import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { User, UserCheck } from 'lucide-react';

export default function AsignarTrabajadorModal({
  open,
  onOpenChange,
  trabajadores,
  titulo,
  descripcion,
  onAsignar,
  tipo = 'responsable', // 'responsable' o 'revisor'
}) {
  const [trabajadorSeleccionado, setTrabajadorSeleccionado] = useState('');

  const handleAsignar = () => {
    if (!trabajadorSeleccionado) return;
    
    const trabajador = trabajadores.find(t => t.id === trabajadorSeleccionado);
    onAsignar(trabajador);
    
    // Resetear y cerrar
    setTrabajadorSeleccionado('');
    onOpenChange(false);
  };

  const handleCancelar = () => {
    setTrabajadorSeleccionado('');
    onOpenChange(false);
  };

  const Icon = tipo === 'revisor' ? UserCheck : User;
  const labelTexto = tipo === 'revisor' ? 'Seleccionar Revisor' : 'Seleccionar Responsable';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon className="w-5 h-5 text-emerald-600" />
            {titulo}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            {descripcion}
          </p>

          <div className="space-y-2">
            <Label>{labelTexto} *</Label>
            <Select
              value={trabajadorSeleccionado}
              onValueChange={setTrabajadorSeleccionado}
            >
              <SelectTrigger>
                <SelectValue placeholder="Seleccione un trabajador..." />
              </SelectTrigger>
              <SelectContent>
                {trabajadores.map((trabajador) => (
                  <SelectItem key={trabajador.id} value={trabajador.id}>
                    <div className="flex items-center gap-2">
                      <User className="w-4 h-4" />
                      {trabajador.nombre_completo}
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancelar}>
            Cancelar
          </Button>
          <Button 
            onClick={handleAsignar}
            disabled={!trabajadorSeleccionado}
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            Asignar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
